var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDeleteFill2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_1066_8649)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "url(#pattern0_1066_8649)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_1066_8649",
    x: 0,
    y: 0,
    width: 20,
    height: 24,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 125
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_1066_8649"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0_1066_8649",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_1066_8649",
    transform: "scale(0.0111111)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_1066_8649",
    width: 90,
    height: 90,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFoAAABaCAYAAAA4qEECAAAACXBIWXMAAAsTAAALEwEAmpwYAAACYElEQVR4nO3cPW4TYRjE8T+BBopcAAyiDydIKKAkXABzAUJFaDANEk2o+TDQE1oozAlMA3ThBEkHDYmCQCIuHrTSIlHwEYc33pmX5yeNFLnyjqVda8dZSCmllFJKqTNngdU2Z/JzOBzngc9AtGn+Xsyyy3v3U8k/8iaLLu/bL4puXkuFxW+S2nPoW2DvD0V1nb32FGR7vm++FewKFBn7zK7rN5mbAuXFlLmBqBPAENgRKCkOKdvAI+B4l0U/FSgiZpTmWDsxB3wVKCBmlC/tMWfRVFr0/3bqeEKHmgvEw/aCEZXmE/Cg64thSimllNLs1Xi/YwdB7wWKicLZQNArgWKicEYIeixQTBROcwtYzm2BYqJwBgi6KlBMFE4f0R+4RGVZQtBpgWKicHoIOgpMBMqJQmmO5RiitgQKikLZRNhrgYKiUMYIey5QUBTKOsLuCRQUhbKGsOsCBUWhrCDsskBBUSjLCDsnUFAUygLC5gUKikJpjkVaDQPANgZqGAA2MFDDADDCQA0DwBADNQwAAwzUMAD0MbAkUFT8Yyz+Q6uGAaCHAfcBYKJ8w7+mAWATI84DwBgjzgPAOkacB4A1jKwIFBYHzDWMLAsUFgfMJYw4DwALGHEeAOYx4zgAbGPIcQDYwJDjADDCkOMAMMTQQKC4mDK3MNQXKC6mzBUMOQ4AixhyHAB6GHIbACZON/ydB4BNjDkNAGOMPRMoMPaZ5r3acnps5irGTok/aTfaNO/xJObuChT5t9yhAnPts/FCNPeBI1TkIvAS+ChQ7gfgBXCh61JSSimllFJKKaWUMPQdPaFziuEZeyUAAAAASUVORK5CYII="
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteFill2);
export default __webpack_public_path__ + "static/media/delete_fill_2.c39c6b2bdf6b069c7cafc5fda1431565.svg";
export { ForwardRef as ReactComponent };